"use client";

import { c as _c } from "react/compiler-runtime";
import { LaunchHandoffFlight } from "@/components/launch/LaunchHandoffFlight";

/** App-level mount for the launch flight portal (hub + workbench). */
export function LaunchHandoffRoot() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LaunchHandoffFlight />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}